import { Suspense, lazy } from "react";

const Page = lazy(() => import("./ReleasesSettings").then((m) => ({ default: m.ReleasesSettings })));

export const ReleasesSettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

ReleasesSettingsPage.title = "Releases";
ReleasesSettingsPage.path = "/releases";
ReleasesSettingsPage.exact = true;
ReleasesSettingsPage.menuSection = "sharing";
